"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var colors_1 = require("../../style/colors");
var Heading_1 = __importDefault(require("./Heading"));
var Title_1 = __importDefault(require("./Title"));
var Body_1 = __importDefault(require("./Body"));
var DisplayHeading_1 = __importDefault(require("./DisplayHeading"));
var Text = function (_a) {
    var children = _a.children, color = _a.color, themeColor = _a.themeColor, weight = _a.weight, size = _a.size, transform = _a.transform, font = _a.font, fontStyle = _a.fontStyle, lineHeight = _a.lineHeight, kerning = _a.kerning, align = _a.align, props = __rest(_a, ["children", "color", "themeColor", "weight", "size", "transform", "font", "fontStyle", "lineHeight", "kerning", "align"]);
    var style = react_2.useCallback(function (theme) {
        return react_1.css({
            fontWeight: weight,
            color: themeColor ? theme.color[themeColor].DEFAULT : color,
            fontSize: size,
            textTransform: transform,
            fontFamily: font,
            fontStyle: fontStyle,
            lineHeight: lineHeight,
            fontKerning: kerning,
            textAlign: align,
        });
    }, [color, themeColor, weight, size, transform, font, fontStyle, lineHeight, kerning, align]);
    return (react_1.jsx("span", __assign({ css: style }, props), children));
};
var headingStyle = {
    color: colors_1.SixsenseColor.Gray.DARK_5,
    weight: 600,
};
var paragraphStyle = {
    color: colors_1.SixsenseColor.Gray.DARK_2,
    weight: 400,
};
var regularTextStyle = {
    weight: 400,
};
var H1 = function (props) { return (react_1.jsx(Text, __assign({ size: 40 }, headingStyle, props))); };
var H2 = function (props) { return (react_1.jsx(Text, __assign({ size: 32 }, headingStyle, props))); };
var H3 = function (props) { return (react_1.jsx(Text, __assign({ size: 28 }, headingStyle, props))); };
var H4 = function (props) { return (react_1.jsx(Text, __assign({ size: 24 }, headingStyle, props))); };
var H5 = function (props) { return (react_1.jsx(Text, __assign({ size: 20 }, headingStyle, props))); };
var SectionHeading = function (props) { return (react_1.jsx(Text, __assign({ weight: 600, color: colors_1.SixsenseColor.Gray.DARK_5, transform: props.uppercase ? 'uppercase' : undefined }, props))); };
var Paragraph = function (props) { return (react_1.jsx(Text, __assign({}, paragraphStyle, props))); };
var RegularText = function (props) { return (react_1.jsx(Text, __assign({}, regularTextStyle, props))); };
exports.default = Object.assign(Text, {
    H1: H1,
    H2: H2,
    H3: H3,
    H4: H4,
    H5: H5,
    SectionHeading: SectionHeading,
    Paragraph: Paragraph,
    RegularText: RegularText,
    Heading: Heading_1.default,
    Title: Title_1.default,
    Body: Body_1.default,
    DisplayHeading: DisplayHeading_1.default,
});
